import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import { Button, Toastr, Utils } from "arv-reactcomponents";
import PropTypes from "prop-types";
import { PAYMENTPAGE, Checkout } from "npmlinks-constants";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";
import { checkIfAllareStorePick, decidePG } from "../../utils";
import StickyPricingOverview from "../CheckoutComponents/StickyPricingOverview";
import GTM from "../../analytics/GTM";
import GTMEvents from "../../analytics/eventFactory/GTMEvents";

@withRouter
@inject(
  "PaymentStore",
  "CheckoutStore",
  "CreditCardStore",
  "AddressStore",
  "CodStore",
  "SavedCardStore",
  "NetbankingStore",
  "WalletStore",
  "RazorpayStore",
  "LoyaltyStore",
)
@observer
class PlaceOrderButton extends Component {
  static ShowToastr(message = Checkout.CHECKOUT_MESSAGES.ERROR_MESSAGE) {
    Toastr.showToastr({
      className: "nwc-toastr-list-danger nw-toastr",
      message,
      timeout: 5000,
    });
  }
  static triggerGtmOnPlaceOrder(products, overview) {
    GTM.pushWithEvent(
      {
        value: overview.total,
        currency: GTMEvents.GTM_CURRENCY,
        content_category: products.map(product => product.pcmArticleType),
        content_ids: products.map(product => product.skuId),
        contents: products.map(product => ({
          id: product.skuId,
          quantity: product.qty,
          item_price: product.totalMRP,
        })),
      },
      GTMEvents.PLACE_ORDER,
    );
  }
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: false,
    };
    this.placeOrderClick = this.placeOrderClick.bind(this);
    this.validatePayment = this.validatePayment.bind(this);
    this.isNoPaymentOptionSelected = this.isNoPaymentOptionSelected.bind(this);
    this.getAmountForPaymentOption = this.getAmountForPaymentOption.bind(this);
    this.placeOrderSuccess = this.placeOrderSuccess.bind(this);
    this.placeOrderFailure = this.placeOrderFailure.bind(this);
  }

  get isPaymentFailurePage() {
    return (
      this.props.location.pathname ===
      Checkout.CHECKOUT_ROUTES.SUPPORTED.paymentfailure
    );
  }

  isNoPaymentOptionSelected() {
    const { selectedPaymentOptions } = this.props.PaymentStore;
    return !selectedPaymentOptions.length;
  }
  validatePayment(pricingDetailsParams, cartItems) {
    try {
      const payments = [];
      let razorpayKey = "";
      let requestedPG = "";
      const { placeOrderShippingRequestData } = this.props.CheckoutStore;
      let { pricingDetails = {} } = pricingDetailsParams
        ? { pricingDetailsParams }
        : placeOrderShippingRequestData;
      if (this.isPaymentFailurePage) {
        pricingDetails = pricingDetailsParams || placeOrderShippingRequestData;
      }
      const { selectedPaymentOptions } = this.props.PaymentStore;
      const allStorePicks = checkIfAllareStorePick(
        cartItems || this.props.CheckoutStore.cartItems,
      );

      let errorMessage;
      if (this.isNoPaymentOptionSelected()) {
        errorMessage = PAYMENTPAGE.ERRORS.NO_PAYMENT_METHOD;
      }
      if (errorMessage) {
        PlaceOrderButton.ShowToastr(errorMessage);
        return;
      }
      selectedPaymentOptions.every(paymentOption => {
        let paymentRequest = {};
        switch (paymentOption) {
          case PAYMENTPAGE.ORDER_REQUEST.CASH_ON_DELIVERY:
            if (!this.props.CodStore.isCodVerified) {
              errorMessage = allStorePicks
                ? PAYMENTPAGE.ERRORS.CAPTCHA_NOT_VERIFIED
                : PAYMENTPAGE.ERRORS.OTP_NOT_VERIFIED;
            } else {
              errorMessage = "";
            }
            paymentRequest = Object.assign(
              {},
              this.props.CodStore.paymentRequest,
              {
                amount: this.getAmountForPaymentOption(
                  pricingDetails.netAmount,
                  selectedPaymentOptions,
                ),
              },
            );
            break;
          case "SAVEDCARD":
            if (!this.props.SavedCardStore.cvvData.isValid) {
              errorMessage = this.props.SavedCardStore.cvvData.cardCvv
                ? PAYMENTPAGE.ERRORS.CVV_ERROR
                : PAYMENTPAGE.ERRORS.CVV_EMPTY;
            } else {
              errorMessage = "";
            }
            paymentRequest = Object.assign(
              {},
              this.props.SavedCardStore.paymentRequest,
              {
                amount: this.getAmountForPaymentOption(
                  pricingDetails.netAmount,
                  selectedPaymentOptions,
                ),
              },
            );
            razorpayKey = paymentRequest.razorpayKey;
            requestedPG = paymentRequest.requestedPG;
            break;
          case PAYMENTPAGE.ORDER_REQUEST.CREDIT_CARD:
            errorMessage = !this.props.CreditCardStore.cardInfoEntered
              ? PAYMENTPAGE.ERRORS.CARD_INFO_NOT_ENTERED
              : "";
            paymentRequest = Object.assign(
              {},
              this.props.CreditCardStore.paymentRequest,
              {
                amount: this.getAmountForPaymentOption(
                  pricingDetails.netAmount,
                  selectedPaymentOptions,
                ),
              },
            );
            razorpayKey = paymentRequest.razorpayKey;
            requestedPG = paymentRequest.requestedPG;
            break;
          case PAYMENTPAGE.ORDER_REQUEST.NET_BANKING:
            errorMessage = !this.props.PaymentStore.bankSelected
              ? PAYMENTPAGE.ERRORS.NO_BANK_SELECTED
              : "";
            paymentRequest = Object.assign(
              {},
              this.props.NetbankingStore.paymentRequest,
              {
                amount: this.getAmountForPaymentOption(
                  pricingDetails.netAmount,
                  selectedPaymentOptions,
                ),
              },
            );
            razorpayKey = paymentRequest.razorpayKey;
            requestedPG = paymentRequest.requestedPG;
            break;
          case PAYMENTPAGE.ORDER_REQUEST.WALLET:
            errorMessage = !this.props.WalletStore.selectedWalletCode
              ? PAYMENTPAGE.ERRORS.NO_WALLET_SELECTED
              : "";
            if (
              this.props.WalletStore.selectedWallet &&
              this.props.WalletStore.selectedWallet.sendOTPFlag
            ) {
              errorMessage = PAYMENTPAGE.ERRORS.OTP_IS_NOT_VERIFIED;
            }
            paymentRequest = Object.assign(
              {},
              this.props.WalletStore.paymentRequest,
              {
                amount: this.getAmountForPaymentOption(
                  pricingDetails.netAmount,
                  selectedPaymentOptions,
                ),
              },
            );
            requestedPG = paymentRequest.requestedPG;
            razorpayKey = paymentRequest.razorpayKey;
            break;
          case PAYMENTPAGE.ORDER_REQUEST.E_WALLET:
            errorMessage = !this.props.WalletStore.selectedWalletCode || 
            this.props.WalletStore.selectedWalletCode === PAYMENTPAGE.PAYTM
              ? PAYMENTPAGE.ERRORS.NO_WALLET_SELECTED
              : "";
            paymentRequest = Object.assign(
              {},
              this.props.WalletStore.paymentRequestEWallet,
              {
                amount: this.getAmountForPaymentOption(
                  pricingDetails.netAmount,
                  selectedPaymentOptions,
                ),
              },
            );
            requestedPG = paymentRequest.requestedPG;
            razorpayKey = paymentRequest.razorpayKey;
            break;
          case PAYMENTPAGE.ORDER_REQUEST.UPI:
            errorMessage = !this.props.RazorpayStore.upiId
              ? PAYMENTPAGE.ERRORS.UPI_NOT_ADDED
              : "";
            paymentRequest = Object.assign(
              {},
              this.props.RazorpayStore.paymentRequest,
              { amount: pricingDetails.netAmount },
            );
            requestedPG = paymentRequest.requestedPG;
            razorpayKey = paymentRequest.razorpayKey;
            break;
          case PAYMENTPAGE.ORDER_REQUEST.LOYALTY:
            errorMessage = !this.props.LoyaltyStore.isLoyaltyVerified
              ? PAYMENTPAGE.ERRORS.LOYALTY_NOT_VERIFIED
              : "";
            paymentRequest = Object.assign(
              {},
              this.props.LoyaltyStore.paymentRequest,
              { amount: this.props.PaymentStore.loyaltyValue },
            );
            break;
          default:
            errorMessage = "";
        }
        if (errorMessage) {
          return false;
        }
        paymentRequest.amount > 0 ? payments.push(paymentRequest) : null;
        return true;
      });

      if (errorMessage) {
        PlaceOrderButton.ShowToastr(errorMessage);
        return;
      }

      /* Expecting loyalty being sole payment then check whether loyalty is equal to net amount payable
      If not equal then show toastr and return */
      if (
        payments.length === 1 &&
        payments[0].paymentTypeCode === PAYMENTPAGE.ORDER_REQUEST.LOYALTY &&
        payments[0].amount < pricingDetails.netAmount
      ) {
        PlaceOrderButton.ShowToastr(
          PAYMENTPAGE.ERRORS.LOYALTY_INSUFFICIENT_BALANCE,
        );
        return;
      }
      return {
        isValid: true,
        payments,
        razorpayKey,
        requestedPG,
      };
    } catch (err) {
      console.log(err);
    }
  }

  getAmountForPaymentOption(amount, selectedPaymentOptions) {
    let newAmount = amount;
    if (selectedPaymentOptions.length > 1) {
      const { loyaltyValue } = this.props.PaymentStore;
      newAmount = loyaltyValue >= amount ? 0 : amount - loyaltyValue;
    }
    return newAmount;
  }

  getLoyaltyValue(amount) {
    let newAmount = amount;
    const { loyaltyValue } = this.props.PaymentStore;
    newAmount = loyaltyValue >= amount ? loyaltyValue - amount : loyaltyValue;
    return newAmount;
  }

  placeOrderSuccess(paymentResponse, selectedPaymentOptions) {
    switch (selectedPaymentOptions[0]) {
      case PAYMENTPAGE.ORDER_REQUEST.CASH_ON_DELIVERY:
      case PAYMENTPAGE.ORDER_REQUEST.LOYALTY:
        this.props.CodStore.setSuccessFlow(paymentResponse);
        window.location.href = `${window.location.origin}${
          paymentResponse.url
          }`;
        break;
      case PAYMENTPAGE.ORDER_REQUEST.NET_BANKING:
        this.props.NetbankingStore.setSuccessFlow(paymentResponse);
        break;
      case PAYMENTPAGE.ORDER_REQUEST.WALLET:
        let { transactions = {} } = paymentResponse;
        let { banking: { requestParameters = [] } = {} } = transactions;
        if (requestParameters && !requestParameters.length) {
          window.location.href = `${window.location.origin}${
            paymentResponse.url
            }`;
        } else {
          this.props.WalletStore.setSuccessFlow(paymentResponse);
        }
        break;
      case PAYMENTPAGE.ORDER_REQUEST.E_WALLET:
        this.props.WalletStore.setEWalletFlow(paymentResponse);
        break;
      case "SAVEDCARD":
        this.props.SavedCardStore.setSuccessFlow(paymentResponse);
        break;
      case "UPI":
        this.props.RazorpayStore.setSuccessFlow(paymentResponse);
        break;
      default:
        this.props.CreditCardStore.setSuccessFlow(paymentResponse);
        break;
    }
  }
  placeOrderFailure(err) {
    Analytics.trackEvent({
      action: Event.action.PAYMENT_FAILURE,
      category: Event.category.CHECKOUT,
    });
    this.setState({ isDisabled: false });
    this.props.RazorpayStore.cancelRazorpay();
    let exceptionMsg = "";
    // TODO:: get proper error message from backend
    // TODO:: make a payment error object and this will take care of different flow
    const { status } = err;
    const {
      data: { fieldErrors = {} },
    } = err;
    // const { field } = fieldErrors && fieldErrors[0];
    const errorFieldCode =
      fieldErrors && fieldErrors[0] && fieldErrors[0].field;
    const errorFieldMsg =
      fieldErrors && fieldErrors[0] && fieldErrors[0].objectName;
    if (errorFieldCode === PAYMENTPAGE.ERRORS.IMS_OUT_OF_STOCK_KEY) {
      exceptionMsg = "";
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: PAYMENTPAGE.ERRORS.IMS_OUT_OF_STOCK,
        timeout: 5000,
      });
    } else {
      exceptionMsg = PAYMENTPAGE.ERRORS.SOMETHING_ERROR_MSG;
    }
    if (PAYMENTPAGE.ERRORS.PAYTM_ERROR.LIST.includes(errorFieldCode)) {
      exceptionMsg = "";
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: errorFieldMsg,
        timeout: 5000,
      });
      this.props.history.replace(
        Checkout.CHECKOUT_ROUTES.SUPPORTED.payment,
      );
      window.location.reload();
    } else if (status !== 401) {
      this.props.CheckoutStore.setPaymentError(exceptionMsg);
      this.props.history.replace(
        Checkout.CHECKOUT_ROUTES.SUPPORTED.shipping,
      );
    }
  }

  // TODO:: make generic--  load selected payment wallet success
  async placeOrderClick(e) {
    let reqBody;
    let {
      placeOrderShippingRequestData,
      cartItems,
      pricingOverviewData,
    } = this.props.CheckoutStore;
    const { selectedPaymentOptions } = this.props.PaymentStore;
    if (this.isPaymentFailurePage) {
      reqBody = Utils.localStorage.getItem("paymentRequest");
      pricingOverviewData = reqBody.pricingDetails;
      cartItems = reqBody.productsShippingDetails;
      const { isValid, payments, razorpayKey = "", requestedPG } =
        this.validatePayment(pricingOverviewData, cartItems) || {};
      if (!isValid) {
        return;
      }
      reqBody.paymentDetails = {
        payments,
        usennnowcash: 0,
        razorpayKey,
        requestedPG,
      };
    } else {
      if (this.state.isDisabled) {
        e.stopPropagation();
        return;
      }
      const { shippingAddress = {} } = this.props.CheckoutStore;
      const { id: addressId } = shippingAddress || {};
      const { isValid, payments, razorpayKey = "", requestedPG } = this.validatePayment() || {};
      if (!isValid) {
        return;
      }
      const paymentDetails = {
        payments,
        usennnowcash: 0,
        razorpayKey,
        requestedPG,
      };
      reqBody = Object.assign(
        {},
        Object.assign({}, { addressId }, placeOrderShippingRequestData),
        { paymentDetails },
      );
    }
    Analytics.trackEvent({
      action: Event.action.PAYMENT_STEP_2_DONE,
      category: Event.category.CHECKOUT,
    });
    this.setState({ isDisabled: true });
    const amount = this.getAmountForPaymentOption(reqBody.pricingDetails.netAmount, selectedPaymentOptions);
    this.props.RazorpayStore.initRazorpay(amount, reqBody);
    PlaceOrderButton.triggerGtmOnPlaceOrder(cartItems, pricingOverviewData);
    // TODO:: handling error cases:--  payment api error 5XX, payment got failed  but got different url 200
    if (
      this.props.CheckoutStore.shippingAddress &&
      Object.keys(this.props.CheckoutStore.shippingAddress).length
    ) {
      Utils.localStorage.setItem(
        "currentShippingAddress",
        this.props.CheckoutStore.shippingAddress,
      );
    }
    this.props.PaymentStore.placeOrder(reqBody).then(
      paymentResponse => {
        Utils.localStorage.setItem("orderPlaced", true);
        const { PGName } = decidePG(paymentResponse);
        Analytics.trackEvent({
          action: Event.action.SELECTED_PAYMENT_GATEWAY,
          category: Event.category.PAYMENT,
          label: Event.label.getPaymentGateway(reqBody.paymentDetails.requestedPG, PGName),
        });
        this.placeOrderSuccess(paymentResponse, selectedPaymentOptions);
      },
      err => {
        this.placeOrderFailure(err);
      },
    );
  }

  render() {
    const { isDisabled } = this.state;
    return (
      <div className="nwc-mobile-bottom-sticky nw-checkout-buttoncontainer">
        <Button
          className="nwc-btn-primary nwc-btn-sm nw-paymentview-placeorderbutton "
          onClick={this.placeOrderClick}
          disabled={isDisabled}
        >
          {PAYMENTPAGE.PLACEORDER_BUTTON}
        </Button>
      </div>
    );
  }
}

PlaceOrderButton.wrappedComponent.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  CreditCardStore: PropTypes.shape({
    success: PropTypes.shape({}),
    paymentRequest: PropTypes.shape({}),
    setSuccessFlow: PropTypes.func.isRequired,
    cardInfoEntered: PropTypes.bool.isRequired,
  }).isRequired,
  PaymentStore: PropTypes.shape({
    isSavedCardSelected: PropTypes.bool.isRequired,
    selectedPaymentOptions: PropTypes.shape({}),
    placeOrder: PropTypes.func,
    bankSelected: PropTypes.bool.isRequired,
    loyalty: PropTypes.shape({}).isRequired,
    loyaltyValue: PropTypes.number.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    triggerLoader: PropTypes.func.isRequired,
    placeOrderShippingRequestData: PropTypes.shape({}).isRequired,
    cartItems: PropTypes.shape({}).isRequired,
    setPaymentError: PropTypes.func.isRequired,
    pricingOverviewData: PropTypes.shape({}).isRequired,
  }).isRequired,
  SavedCardStore: PropTypes.shape({
    cvvData: PropTypes.shape({
      isValid: PropTypes.bool,
      cardCvv: PropTypes.string,
    }).isRequired,
    setSuccessFlow: PropTypes.func.isRequired,
    paymentRequest: PropTypes.func.isRequired,
  }).isRequired,
  NetbankingStore: PropTypes.shape({
    paymentRequest: PropTypes.func.isRequired,
    setSuccessFlow: PropTypes.func.isRequired,
  }).isRequired,
  AddressStore: PropTypes.shape({
    addressId: PropTypes.shape({}).isRequired,
    mobileNumberVerified: PropTypes.bool.isRequired,
  }).isRequired,
  CodStore: PropTypes.shape({
    setSuccessFlow: PropTypes.func.isRequired,
    validateCaptchaFunc: PropTypes.func.isRequired,
    isCodVerified: PropTypes.bool.isRequired,
    paymentRequest: PropTypes.func.isRequired,
  }).isRequired,
  WalletStore: PropTypes.shape({
    selectedWalletCode: PropTypes.string,
    paymentRequest: PropTypes.func.isRequired,
    setSuccessFlow: PropTypes.func.isRequired,
  }).isRequired,
  RazorpayStore: PropTypes.shape({
    setSuccessFlow: PropTypes.func.isRequired,
    paymentRequest: PropTypes.shape({}).isRequired,
    activateRazorpay: PropTypes.func.isRequired,
    cancelRazorpay: PropTypes.func.isRequired,
  }).isRequired,
  LoyaltyStore: PropTypes.shape({
    isLoyaltyVerified: PropTypes.bool,
    paymentRequest: PropTypes.shape({}),
  }).isRequired,
};

const getFinalComponent = component =>
  inject(
    "PaymentStore",
    "CheckoutStore",
    "CreditCardStore",
    "AddressStore",
    "CodStore",
    "SavedCardStore",
    "NetbankingStore",
    "WalletStore",
  )(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: PlaceOrderButton.wrappedComponent,
  component: PlaceOrderButton,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PlaceOrderButton/index.js